var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDeleteButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 3.99992H14.6667V5.33325H13.3334V13.9999C13.3334 14.1767 13.2631 14.3463 13.1381 14.4713C13.0131 14.5963 12.8435 14.6666 12.6667 14.6666H3.33337C3.15656 14.6666 2.98699 14.5963 2.86197 14.4713C2.73695 14.3463 2.66671 14.1767 2.66671 13.9999V5.33325H1.33337V3.99992H4.66671V1.99992C4.66671 1.82311 4.73695 1.65354 4.86197 1.52851C4.98699 1.40349 5.15656 1.33325 5.33337 1.33325H10.6667C10.8435 1.33325 11.0131 1.40349 11.1381 1.52851C11.2631 1.65354 11.3334 1.82311 11.3334 1.99992V3.99992ZM12 5.33325H4.00004V13.3333H12V5.33325ZM6.00004 7.33325H7.33337V11.3333H6.00004V7.33325ZM8.66671 7.33325H10V11.3333H8.66671V7.33325ZM6.00004 2.66659V3.99992H10V2.66659H6.00004Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteButton);
export default __webpack_public_path__ + "static/media/icon_delete_button.912277850d2c32597bad11daa7d29533.svg";
export { ForwardRef as ReactComponent };